import { Routes } from '@angular/router';
import { GuestGuard } from './utils/guards/guest.guard';
import { AuthGuard } from './utils/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    canActivate: [GuestGuard],
    loadChildren: () =>
      import('./pages/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/home/home').then((m) => m.Home),
    loadChildren: () =>
      import('./pages/home/home.routes').then((m) => m.HOME_ROUTES),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./pages/auth/new-password/new-password').then(
        (m) => m.NewPassword
      ),
  },
  {
    path: '**',
    redirectTo: 'auth/login',
  },
];